'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { Card, CardContent } from '@/components/ui/card';
import { LoginForm } from '@/components/auth/login-form';
import { RegisterForm } from '@/components/auth/register-form';

export default function LoginPage() {
  const [showRegister, setShowRegister] = useState(false);
  const router = useRouter();

  return (
    <Card>
      <CardContent className="pt-6">
        {!showRegister ? (
          <LoginForm
            onSwitchToRegister={() => setShowRegister(true)}
            onForgotPassword={() => router.push('/esqueceu-senha')}
          />
        ) : (
          <RegisterForm onSwitchToLogin={() => setShowRegister(false)} />
        )}
      </CardContent>
    </Card>
  );
}
